
// components/SwEventDrawer/components/TicketDetailsSection.jsx
import React from 'react';
import { Trash2, Plus } from "lucide-react";
import SpInput from '../../SpInput/SpInput';

const TicketDetailsSection = ({ 
  formik, 
  handleTicketTypeChange, 
  getTicketTypeError, 
  addNewTicketType, 
  removeTicketType 
}) => {
  return (
    <div className="sw-event-modal-section">
      <div className="sw-event-section-header">
        Ticket Details
      </div>
      
      <div className="sw-ticket-details-header">
        <div className="sw-ticket-header-label">
          Access Type
        </div>
        <div className="sw-ticket-header-label">
          Price
        </div>
        <div className="sw-ticket-header-label">
          Description
        </div>
        <div className="sw-ticket-header-spacer"></div>
      </div>

      {formik.values.ticketTypes.map((ticket, index) => (
        <div key={index} className="sw-ticket-row">
          <div className="sw-ticket-input">
            <SpInput
              placeholder="Access type"
              value={ticket.accessType}
              onChange={(e) => handleTicketTypeChange(index, 'accessType', e.target.value)}
              onBlur={() => formik.setFieldTouched(`ticketTypes[${index}].accessType`, true)}
              error={getTicketTypeError(index, 'accessType')}
            />
          </div>
          <div className="sw-ticket-input">
            <SpInput
              placeholder="Price"
              type="number"
              value={ticket.price}
              onChange={(e) => handleTicketTypeChange(index, 'price', e.target.value)}
              onBlur={() => formik.setFieldTouched(`ticketTypes[${index}].price`, true)}
              error={getTicketTypeError(index, 'price')}
            />
          </div>
          <div className="sw-ticket-input">
            <SpInput
              placeholder="Description (optional)"
              value={ticket.description}
              onChange={(e) => handleTicketTypeChange(index, 'description', e.target.value)}
              onBlur={() => formik.setFieldTouched(`ticketTypes[${index}].description`, true)}
              error={getTicketTypeError(index, 'description')}
            />
          </div>
          {formik.values.ticketTypes.length > 1 && (
            <button
              type="button"
              onClick={() => removeTicketType(index)}
              className="sw-ticket-delete-btn"
            >
              <Trash2 size={16} />
            </button>
          )}
        </div>
      ))}

      {/* Show ticket types validation error */}
      {formik.touched.ticketTypes && formik.errors.ticketTypes && typeof formik.errors.ticketTypes === 'string' && (
        <div style={{ color: '#ff4d4f', fontSize: 12, marginTop: 8 }}>
          {formik.errors.ticketTypes}
        </div>
      )}

      <button
        type="button"
        onClick={addNewTicketType}
        className="sw-add-ticket-btn"
      >
        <Plus size={16} />
        Add New Access
      </button>
    </div>
  );
};

export default TicketDetailsSection;